import React from 'react'

const Map = () => {
  return (
    <div className="">
        <div className="w-full">
        <iframe className="w-full h-80 lg:h-[554px] rounded-[6px]"
                        title="mapTitle"
                        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2934.6485239079343!2d21.140617675089274!3d42.6476106168879!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x13549e8a6d1b0d25%3A0x2224dece7293bb46!2sTahir%20Zajmi%2C%20Prishtina!5e0!3m2!1sen!2s!4v1697161615344!5m2!1sen!2s" 
                        allowFullScreen="" aria-hidden="false"
                        tabIndex="0"></iframe>
        </div>
    </div>
  )
}

export default Map